const { mapValues, invert, transform, omit } = require('lodash');

const { keys } = Object;

const deliveryTypes = {
  yamato: { label: 'ヤマト', code: 'yamatohatu', company: 'yamato', shopifyLabel: 'Yamato (JA)', rakutenNumber: 1001, yahooNumber: 1001, },
  neko: { label: 'ネコポス', code: 'yamatoneko', company: 'yamato', shopifyLabel: 'Yamato (JA)', rakutenNumber: 1001, yahooNumber: 1001, },
  'yamato-cod': { label: 'ヤマト(着払い)', code: 'yamatotyaku', company: 'yamato', shopifyLabel: 'Yamato (JA)', rakutenNumber: 1001, yahooNumber: 1001, },
  'yamato-cod-all': { label: 'ヤマト(代引き)', code: 'yamatodaibiki', company: 'yamato', shopifyLabel: 'Yamato (JA)', rakutenNumber: 1001, yahooNumber: 1001, },
  sagawa: { label: '佐川', code: 'sagawahatu', company: 'sagawa', shopifyLabel: 'Sagawa (JA)', rakutenNumber: 1002, yahooNumber: 1002, },
  'sagawa-cod': { label: '佐川(着払い)', code: 'sagawatyaku', company: 'sagawa', shopifyLabel: 'Sagawa (JA)', rakutenNumber: 1002, yahooNumber: 1002, },
  'sagawa-cod-all': { label: '佐川(代引き)', code: 'sagawadaibiki', company: 'sagawa', shopifyLabel: 'Sagawa (JA)', rakutenNumber: 1002, yahooNumber: 1002, },
  nihon: { label: '日本郵便', code: 'nihonhatu', company: 'nihon', shopifyLabel: 'Japan Post (JA)', rakutenNumber: 1003, yahooNumber: 1003, },
  'nihon-cod': { label: '日本郵便(着払い)', code: 'nihontyaku', company: 'nihon', shopifyLabel: 'Japan Post (JA)', rakutenNumber: 1004, yahooNumber: 1004, },
  'nihon-cod-all': { label: '日本郵便(代引き)', code: 'nihondaibiki', company: 'nihon', shopifyLabel: 'Japan Post (JA)', rakutenNumber: 1003, yahooNumber: 1003, },
  fukuyama: { label: '福山', code: 'fukuyamahatu', company: 'fukuyama', shopifyLabel: '福山通運', rakutenNumber: 1006, yahooNumber: 1006, },
  'fukuyama-cod': { label: '福山(着払い)', code: 'fukuyamatyaku', company: 'fukuyama', shopifyLabel: '福山通運', rakutenNumber: 1006, yahooNumber: 1006, },
  'fukuyama-cod-all': { label: '福山(代引き)', code: 'fukuyamadaibiki', company: 'fukuyama', shopifyLabel: '福山通運', rakutenNumber: 1006, yahooNumber: 1006, },
  seino: { label: '西濃', code: 'seinohatu', company: 'seino', shopifyLabel: '西濃運輸', rakutenNumber: 1004, yahooNumber: 1004, },
  'seino-cod': { label: '西濃(着払い)', code: 'seinotyaku', company: 'seino', shopifyLabel: '西濃運輸', rakutenNumber: 1004, yahooNumber: 1004, },
  'seino-cod-all': { label: '西濃(代引き)', code: 'seinodaibiki', company: 'seino', shopifyLabel: '西濃運輸', rakutenNumber: 1004, yahooNumber: 1004, },
  amazon: { label: 'Amazon納品', code: 'amazon', company: 'amazon', },
};
const deliveryCarriers = keys(omit(deliveryTypes, ['amazon', 'neko'])).filter(_ => !_.includes('-'));
const boxSizes = {
  neko: { label: 'ネコポス', volume: 2112, },
  size60: { label: '60サイズ', volume: 4032, },
  size80: { label: '80サイズ', volume: 16368, },
  size100: { label: '100サイズ', volume: 28718, },
  size120: { label: '120サイズ', volume: 52974, },
  size140: { label: '140サイズ', volume: 93133, },
  size160: { label: '160サイズ', volume: 129200, },
  size170: { label: '170サイズ', volume: 129200, },
  size180: { label: '180サイズ', volume: 129200, },
  size200: { label: '200サイズ', volume: 129200, },
  size220: { label: '220サイズ', volume: 129200, },
  size240: { label: '240サイズ', volume: 129200, },
  size260: { label: '260サイズ', volume: 129200, },
};
const boxSizesForCount = {
  ...boxSizes,
  ...transform(omit(boxSizes, 'neko'), (x, v, k) => {
    x[['amazon', k].join('__')] = {
      ...v, label: ['FBA', v.label].join(' '),
    };
  }),
  unknown: { label: '不明サイズ' },
  amazon: { label: 'FBA配送箱数', },
  discard: { label: '廃棄' },
};
//ネコポス	32	22	3	2112
//60	19.5	14.5	0.95	268.6125
//60	21	16	12	4032
//60	26	19	11	5434
//80	31	22	24	16368
//80	39.5	29.5	0.95	1106.9875
//100	46.5	32	19.3	28718.4
//120	56.5	32	29.3	52974.4
//140	60.5	43	35.8	93133.7
//160	68	38	50	129200

const amazonProductSizeTypes = {
  small: { label: '標準以下' },
  large: { label: '大型以上' },
  unknown: { label: 'サイズ不明' },
};

const deliveryTimes = {
  free: { type: 'all', format: '', label: '指定なし', },
  sagawa8: { type: 'sagawa', format: 'am', forShippingCsv: '01', forFukuyamaShippingCsv: '110', label: '午前中（8時～12時）', shopify: '0812', rakuten: '0812', yahoo: '0812', api: '08-12', },
  sagawa12: { type: 'sagawa', format: '12-14', forShippingCsv: '12', forFukuyamaShippingCsv: '112', label: '12時～14時', shopify: '1214', rakuten: '1214', yahoo: '1214', api: '12-14', },
  sagawa14: { type: 'sagawa', format: '14-16', forShippingCsv: '14', forFukuyamaShippingCsv: '114', label: '14時～16時', shopify: '1416', rakuten: '1416', yahoo: '1416', api: '14-16', },
  sagawa16: { type: 'sagawa', format: '16-18', forShippingCsv: '16', forFukuyamaShippingCsv: '116', label: '16時～18時', shopify: '1618', rakuten: '1618', yahoo: '1618', api: '16-18', },
  sagawa18: { type: 'sagawa', format: '18-20', forShippingCsv: '18', forFukuyamaShippingCsv: '118', label: '18時～20時', shopify: '1820', rakuten: '1820', yahoo: '1820', api: '18-20', },
  sagawa1821: { type: 'sagawa', format: '18-21', forShippingCsv: '04', label: '18時～21時', forFukuyamaShippingCsv: '118', yahoo: '1821', api: '18-21', },
  sagawa19: { type: 'sagawa', format: '19-21', forShippingCsv: '19', label: '19時～21時', forFukuyamaShippingCsv: '118', shopify: '1921', rakuten: '1921', yahoo: '1921', api: '19-21', },
  yamato8: { type: 'yamato', format: '0812', forShippingCsv: '0812', forFukuyamaShippingCsv: '110', label: '午前中（8時～12時）', },
  yamato12: { type: 'yamato', format: '1214', forShippingCsv: '1214', forFukuyamaShippingCsv: '112', label: '12時～14時', },
  yamato14: { type: 'yamato', format: '1416', forShippingCsv: '1416', forFukuyamaShippingCsv: '114', label: '14時～16時', },
  yamato16: { type: 'yamato', format: '1618', forShippingCsv: '1618', forFukuyamaShippingCsv: '116', label: '16時～18時', },
  yamato18: { type: 'yamato', format: '1820', forShippingCsv: '1820', forFukuyamaShippingCsv: '118', label: '18時～20時', },
  yamato19: { type: 'yamato', format: '1921', forShippingCsv: '1921', label: '19時～21時', forFukuyamaShippingCsv: '118', },
};

const prefectures = {
  1: '北海道', 2: '青森県', 3: '岩手県', 4: '宮城県', 5: '秋田県',
  6: '山形県', 7: '福島県', 8: '茨城県', 9: '栃木県', 10: '群馬県',
  11: '埼玉県', 12: '千葉県', 13: '東京都', 14: '神奈川県', 15: '新潟県',
  16: '富山県', 17: '石川県', 18: '福井県', 19: '山梨県', 20: '長野県',
  21: '岐阜県', 22: '静岡県', 23: '愛知県', 24: '三重県', 25: '滋賀県',
  26: '京都府', 27: '大阪府', 28: '兵庫県', 29: '奈良県', 30: '和歌山県',
  31: '鳥取県', 32: '島根県', 33: '岡山県', 34: '広島県', 35: '山口県',
  36: '徳島県', 37: '香川県', 38: '愛媛県', 39: '高知県', 40: '福岡県',
  41: '佐賀県', 42: '長崎県', 43: '熊本県', 44: '大分県', 45: '宮崎県',
  46: '鹿児島県', 47: '沖縄県',
};
const romaPrefectures = {
  Hokkaido: '1',
  Aomori: '2',
  Iwate: '3',
  Miyagi: '4',
  Akita: '5',
  Yamagata: '6',
  Fukushima: '7',
  Ibaraki: '8',
  Tochigi: '9',
  Gunma: '10',
  Saitama: '11',
  Chiba: '12',
  Tokyo: '13',
  Kanagawa: '14',
  Niigata: '15',
  Toyama: '16',
  Ishikawa: '17',
  Fukui: '18',
  Yamanashi: '19',
  Nagano: '20',
  Gifu: '21',
  Shizuoka: '22',
  Aichi: '23',
  Mie: '24',
  Shiga: '25',
  Kyoto: '26',
  Osaka: '27',
  Hyogo: '28',
  Nara: '29',
  Wakayama: '30',
  Tottori: '31',
  Shimane: '32',
  Okayama: '33',
  Hiroshima: '34',
  Yamaguchi: '35',
  Tokushima: '36',
  Kagawa: '37',
  Ehime: '38',
  Kochi: '39',
  Fukuoka: '40',
  Saga: '41',
  Nagasaki: '42',
  Kumamoto: '43',
  Oita: '44',
  Miyazaki: '45',
  Kagoshima: '46',
  Okinawa: '47',
};
const prefecturesByName = {
  ...invert(prefectures),
  ...romaPrefectures,
  ...invert(mapValues(prefectures, _ => _.slice(0, _.length - 1))),
};
const colors = [
    '#8dd3c7',
    '#eeeeb3',
    '#bebada',
    '#fb8072',
    '#80b1d3',
    '#fdb462',
    '#b3de69',
    '#fccde5',
    '#d9d9d9',
    '#bc80bd',
    '#ccebc5',
    '#ffed6f',
];
const sysAddress = {
  Name: '藤原 彰仁',
  AddressLine1: '堺市南区美木多上1-1-1',
  AddressLine2: '',
  City: '',
  StateOrProvinceCode: '大阪府',
  PostalCode: '590-0136',
  CountryCode: 'JP',
  DistrictOrCounty: '',
  PhoneNumber: '08011112222',
};
const malls = {
  rakuten: {
    label: '楽天',
    mappingItems: [
      { label: '管理番号', name: 'rakutenManageNumber', },
      { label: 'SKU', name: 'rakutenVariantId', },
    ],
  },
  shopify: {
    label: 'Shopify',
    mappingItems: [
      { label: 'SKU', name: 'shopifySku', },
    ],
  },
  mercari: {
    label: 'メルカリ',
    mappingItems: [
      { label: 'SKU', name: 'mercariSku', },
    ],
  },
  yahoo: {
    label: 'Yahoo',
    mappingItems: [
      { label: '商品コード', name: 'itemCode', },
      { label: '個別商品コード', name: 'subCode', },
    ],
  },
  tts: {
    label: 'TikTok Shop',
    mappingItems: [
      { label: 'SKU', name: 'ttsSku', },
    ],
  },
  qoo10: {
    label: 'Qoo10',
    mappingItems: [
      { label: '販売者商品コード', name: 'qoo10ItemCode', },
      { label: '販売者オプションコード', name: 'qoo10OptionCode', },
    ],
  },
};

const mallOrderSkipReasons = {
  outsideLocation: '出荷元ロケーション外の注文',
  invalidPostalCode: '国内の配送先ではない',
  unmappedProducts: '商品対応表が未登録',
  macro: 'マクロにより除外',
};

module.exports = {
  boxSizes,
  boxSizesForCount,
  amazonProductSizeTypes,
  deliveryTimes,
  prefectures,
  prefecturesByName,
  romaPrefectures,
  colors,
  sysAddress,
  deliveryTypes,
  deliveryCarriers,
  malls,
  mallOrderSkipReasons,
};
